import { matchPath } from "react-router-dom";

// These modules use page-level filters instead of a global facility selection.
const ORGANISATION_MODULE_PATHS = [
  "/organisation/facilities",
  "/organisation/employees",
  "/dashboard",
  "/reports",
  "/report-asset",
  "/organisation/disclosures",
];

/** Shared by the header and AI context so hidden selectors cannot leak scope. */
export function usesGlobalFacilitySelection(pathname: string): boolean {
  return !ORGANISATION_MODULE_PATHS.some((path) =>
    matchPath({ path, end: false }, pathname),
  );
}
